// Enum for background colors used in vs-quote
export enum BackgroundColor {
  VsTertiary = 'vs-tertiary',
  VsSecondary = 'vs-secondary',
  VsPrimary = 'vs-primary',
  VsPrimaryDark = 'vs-primary-dark',
  VsLightBlue = 'vs-lightBlue',
}
